/**
 * @module imports/ajax
 * @requires module:imports/auth
 * @requires module:imports/history
 */

import * as axios from 'axios';
import * as auth from './auth';
import {ajaxErrorHandling} from './errorHandling';

/**
 * api base url from env config
 * @constant {string} baseUrl 
 * @private
 */
const baseUrl = process.env.REACT_APP_BASE_URL;

/**
 * time out for request to api service
 * @constant {number} timeout
 * @private
 */
const timeout = 90000;

/**
 * instance of axios that create xhr request to send json data
 * @constant ajaxJson
 */
export const ajaxJson = axios.create({
    baseURL: baseUrl,
    timeout: timeout,
    headers: {
        'Content-type': 'application/json',
    }
});

/**
 * instance of axios that create xhr request to send form data
 * @constant ajaxFD
 */
export const ajaxFD = axios.create({
    baseURL: baseUrl,
    timeout: timeout,
    headers: {}
});

/**
 * it will call before each sending request.
 * set the jwt token to authorization of header.
 * @function authHeaderReqInterceptor[0]
 * @param {Object} config axios config object
 * @returns {Object} updated axios config
 * @private
 */

 /**
 * if request can not sending and catch error it will be call.
 * @function authHeaderReqInterceptor[1]
 * @param {any} err error
 * @returns {Promise<never>}
 * @private
 */
const authHeaderReqInterceptor = [
    (config) => {
        if (auth.isLogin()) {
            config.headers['Authorization'] = `Bearer ${auth.getUser().token}`;
        } else {
            delete config.headers['Authorization'];
        }
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
];

/**
 * it will call before each receive response.
 * @function authErrorResInterceptor[0]
 * @param {Object} res response object
 * @returns {Object} updated response object
 * @private
 */



const errorHandlingResInterceptor = [
    (res) => {
        return res;
    }, 
    (err) => {
        ajaxErrorHandling(err)
        return Promise.reject(err);
    }
];


// setup authHeaderReqInterceptor , authErrorResInterceptor on ajaxJson
ajaxJson.interceptors.request.use(...authHeaderReqInterceptor);
ajaxJson.interceptors.response.use(...errorHandlingResInterceptor);

// setup authHeaderReqInterceptor , authErrorResInterceptor on ajaxFD
ajaxFD.interceptors.request.use(...authHeaderReqInterceptor);
ajaxFD.interceptors.response.use(...errorHandlingResInterceptor);